import { api } from '@/api'
import type { PermissionItem } from '@/api/typings/permissions.typing'
import type { ApiResponse } from '@/api/typings/response.typing'

export function getPermissionsAction(): Promise<ApiResponse<PermissionItem[]>> {
  return api.get<ApiResponse<PermissionItem[]>>('/permissions')
}
